module.exports = __webpack_public_path__ + "static/media/image-gallery-3.f5141c00.jpg";